import React, { useState } from 'react';
import { Form, Input, Alert, Typography, Card, Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { AuthAPI } from '../api/authApi';
import styles from './login.module.scss';

const { Title } = Typography;

const ForgotPassword = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleEmailSubmit = async (values) => {
    const { email } = values;
    if (!email) {
      setError('Molimo unesite email');
      return;
    }

    // Odgovor se namerno ne prikazuje (ne otkrivamo da li nalog postoji).
    await AuthAPI.forgotPassword({ email });
    navigate(`/promenite-sifru?email=${encodeURIComponent(email)}`);
  };

  return (
    <div className={styles.login}>
      <div className={styles.login__left}>
        <div className={styles.login__logo}>
          <Link to="/">
            <img src="/logo.svg" alt="Logo" height={30} width={100} />
          </Link>
        </div>
        <div className={styles.login__formCard}>
          <Card className={styles.login__card}>
            <Title className={styles.login__title} level={1}>
              Promenite sifru
            </Title>
            <p className={styles.login__subtitle}>
              Molimo vas da unesete email adresu koja je uneta pri registraciji
              kako bismo vam poslali link za promenu šifre.
            </p>
            <Form layout="vertical" onFinish={handleEmailSubmit}>
              <Form.Item
                label="E-mail"
                name="email"
                rules={[{ required: true, message: 'Unesite email!' }]}
              >
                <Input />
              </Form.Item>

              {error && (
                <Alert
                  title={error}
                  type="error"
                  showIcon
                  style={{ marginBottom: 16 }}
                />
              )}

              <Form.Item className={styles.login__submit}>
                <Button type="primary" htmlType="submit">
                  Pošalji link
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </div>
      <div className={styles.login__right}></div>
    </div>
  );
};

export default ForgotPassword;
